import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material';

interface Props {
  onClose: () => void;
  newsUrl: string;
}

function DashboardNewsDialog(props: Props) {
  const { onClose, newsUrl } = props;

  return (
    <Dialog
      open
      fullWidth
      maxWidth="xl"
      fullScreen={false}
      slotProps={{
        paper: {
          style: {
            height: '90vh',
          },
        },
      }}
    >
      <DialogTitle>News</DialogTitle>
      <DialogContent sx={{}}>
        <iframe
          title="NEWS"
          style={{
            width: '100%',
            height: '98%',
            border: 'none',
          }}
          src={newsUrl}
        />
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={onClose}>
          Chiudi
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default DashboardNewsDialog;
